<template>
  <div v-if="appointment && encounter" class="modal modal-app modal-encounter" tabindex="-1">
    <div class="modal-dialog modal-lg" :class="[$route.meta.fullPageSlide ? 'full-page-slide' : '']">
      <div class="modal-content">
        <div class="modal-body">

          <div class="d-flex justify-content-between align-items-center modal-header">
            <div class="flex-grow">
              <p v-if="encounter && encounter.encounter_type" class="snug">Encounter Slides</p>
              <p v-if="!encounter" class="snug">No encounter data found. You must begin appointment setup in order to view encounter slides.</p>
            </div>
            <button class="btn btn-icon" @click="$emit('close')"><i class="fas fa-times"></i></button>
          </div>

          <div v-if="encounter" class="encounter-container">

              <div v-if="encounter.encounter_type" class="row-encounter-nav row">
                <div class="col-3">
                  <h5 v-if="encounter.encounter_type=='tpPresentation'" class="snug"><strong>Understanding Your Treatment Plan</strong></h5>
                </div>
                <div v-if="encounterComponentSequence" class="col-9 text-right">
                  <div class="row row-step-nav justify-content-end align-items-center">
                    <div class="step-nav-counter"><p class="snug">
                      {{ activeComponentIndex+1 }} of
                      <span>{{ encounterComponentSequence[encounter.encounter_type].length }}</span>
                    </p></div>
                    <div class="step-nav d-flex justify-content-end align-items-center">
                      <button
                        class="step btn btn-link"
                        v-for="c in encounterComponentSequence[this.encounter.encounter_type]"
                        @click="currentSlideComponent = c"
                        :class="{'active': currentSlideComponent === c}"
                        :key="c.name"
                        :disabled="!encounterData"
                      >
                        <span class="cir"></span>
                        <span class="label">{{ c.name }}</span>
                      </button>
                    </div>
                  </div> <!-- /.row -->
                </div> <!-- /.col -->
              </div> <!-- /.row -->

              <p v-if="!encounterData || !appointment || !encounter" class="alert alert-custom text-center">Missing required data. Please <router-link to="/appointments">go back</router-link> and re-select the appointment to continue.</p>

              <p class="loading text-center" v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i> loading encounter data, this might take a moment...</p>

              <component
                :is="currentSlideComponent.component"
                v-if="!loading && encounterData && currentSlideComponent"
                :encounterData="encounterData"
                v-on:back="handleBack"
                v-on:forward="handleForward"
                v-on:update-encounter-data="handleUpdateEncounterData"
                class="encounter-body"
              />

          </div> <!-- /.encounter-container -->
        </div> <!-- /.modal-body -->
      </div> <!-- /.modal-content -->
    </div> <!-- /.modal-dialog -->
  </div> <!-- /.modal-encounter -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
// import slide components
import AppointmentEncounterType from '../components/AppointmentEncounterType.vue'
import Encounter_tpGoal from '../components/Encounter_tpGoal.vue'
import Encounter_tpProblem from '../components/Encounter_tpProblem.vue'
import Encounter_tpChart from '../components/Encounter_tpChart.vue'
import Encounter_tpAdvancing from '../components/Encounter_tpAdvancing.vue'
import Encounter_tpRebuilding from '../components/Encounter_tpRebuilding.vue'
import Encounter_tpProtection from '../components/Encounter_tpProtection.vue'
import Encounter_tpSavings from '../components/Encounter_tpSavings.vue'
import Encounter_tpSchedule from '../components/Encounter_tpSchedule.vue'
import ViewPlan from '../views/ViewPlan.vue'

export default {
  props: ['customer'],
  components: {
    ListErrors,
    AppointmentEncounterType,
    // tpPresentation slides
    Encounter_tpGoal, Encounter_tpProblem, Encounter_tpChart, Encounter_tpAdvancing, Encounter_tpRebuilding, Encounter_tpProtection, Encounter_tpSavings, ViewPlan, Encounter_tpSchedule
  },
  data () {
    return {
      errors: [],
      loading: false,
      currentSlideComponent: null,
      encounterData: {},
      appointmentTypeSelectComponent: {component: AppointmentEncounterType, name: 'appointment type'},
      encounterComponentSequence: {
        'tpPresentation': [
          {component: Encounter_tpGoal, name: 'goal'},
          {component: Encounter_tpProblem, name: 'problem'},
          {component: Encounter_tpChart, name: 'chart'},
          {component: Encounter_tpAdvancing, name: 'advancing'},
          {component: Encounter_tpRebuilding, name: 'rebuilding'},
          {component: Encounter_tpProtection, name: 'protection'},
          {component: Encounter_tpSavings, name: 'savings'},
          {component: ViewPlan, name: 'sign'},
          {component: Encounter_tpSchedule, name: 'schedule'},
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
    activeComponentIndex() {
      // calculate index based on position in encounterComponentSequence
      if(!this.encounterComponentSequence) return 0;
      let currentIndex = this.encounterComponentSequence[this.encounter.encounter_type].findIndex(c => c === this.currentSlideComponent);
      // currentIndex += 1;
      // // adjust for PostEncounter route if present
      // if(this.currentSlideComponent === Encounter_tpPostEncounter) {
      //   return currentIndex - 1;
      // }
      return currentIndex;
    },
  },
  watch: {
    encounter(newVal, oldVal){
      // if encounter has no encounter type, redirect to encounter type select page subroute
      if(!newVal || !newVal.encounter_type) {
        // console.log('No encounter type found, showing appointment type select');
        this.currentSlideComponent = this.appointmentTypeSelectComponent;
      }
      // reset encounterData and load required data for new encounter type
      // this.encounterData = {
      //   slides_completed: [],
      // };
      if(newVal && newVal.encounter_type) {
        this.loadEncounterData();
      }
    },
  },
  methods: {
    exitEncounter() {
      this.$store.dispatch('clearEncounter');
      this.$store.dispatch('clearAppointment');
      this.$store.dispatch('clearPatNum');
      this.$store.dispatch('clearPatName');
      this.$store.dispatch('clearTreatmentPlan');
      this.$router.push({ name: 'appointmentSelect' });
    },
    // load required encounter data based on encounter type
    loadEncounterData() {
      console.log('loadEncounterData called for encounter type:', this.encounter.encounter_type);
      if(!this.encounter || !this.encounter.encounter_type) {
        console.error('No encounter or encounter type found');
        return;
      }
      // validate data required for all encounter types
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        console.error('Missing required user or custom claims data');
        return;
      }
      let loadingPromise;
      this.loading = true;
      if(this.encounter.encounter_type === 'tpPresentation') {
        // load treatment plan presentation data
        loadingPromise = this.loadEncounterDataTpPresentation();

      } else {
        // other encounter types
        // for now, set loadingPromise to resolved true
        loadingPromise = Promise.resolve(true);
      }
      loadingPromise.then(result => {
          if(result) {
            // console.log('Encounter data loaded:', this.encounterData);
            console.log('Encounter data loaded');
          } else {
            console.log('No encounter data loaded');
          }
          // set first slide component
          this.currentSlideComponent = this.encounterComponentSequence[this.encounter.encounter_type][0];
          this.loading = false;
        })
        .catch(err => {
          console.error('Error loading encounter data:', err);
          this.loading = false;
        });
    },
    async loadEncounterDataTpPresentation() {
      // validate
      if(!this.encounter || !this.encounter.treat_plan_num) {
        console.error('No treatment plan found');
        return false;
      }
      if(!this.pat_num || !this.pat_num.toString().length > 10 || !Number.isInteger(this.pat_num)) {
        console.log("invalid patNum");
        return false;
      }
      let promises = [];

      // load treatment plan data
      var loadPlanDataFunc = Vue.functions.httpsCallable('loadPlanData');
      let planDataProm = loadPlanDataFunc({
        TreatPlanNum: this.encounter.treat_plan_num,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPlanData result',result);
          this.loading = false;
          if(result && result.data && result.data.length) {
            this.$set(this.encounterData, 'treatPlanData', result.data);
            return true;
          } else {
            this.errors.push("no treatment plan data found for that Plan Number");
            return false;
          }
        });
      promises.push(planDataProm);

      // load patient goal
      var loadPatInfoFunc = Vue.functions.httpsCallable('loadPatientInfo');
      let patientGoalProm = loadPatInfoFunc({
        patNum: this.pat_num,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPatInfo result',result);
          // this.loading = false;
          if(result && result.data && result.data.length) {
            this.$set(this.encounterData, 'patGoal', result.data);
            return true;
          } else {
            console.log("no patient info data found for that PatNum");
            return false;
          }
        });
      promises.push(patientGoalProm);

      // load tp photos
      // or use the ImageGallery.vue component?
      // or just load again inside the single slide that uses them?

      // load location's procedure categories
      let loadLocProm = Vue.firestore
        .doc(`customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}`)
        .get()
        .then(locSnap => {
          if(locSnap.exists && locSnap.data()) {
            if(locSnap.data().proc_cats) {
              // this.encounterData.locationProcCats = locSnap.data().proc_cats;
              this.$set(this.encounterData, 'locationProcCats', locSnap.data().proc_cats);
              return true;
            } else {
              console.log('no proc_cats field found in location data');
              return false;
            }
          }
          console.log('no location data found');
          return false;
        });
      promises.push(loadLocProm);

      return Promise.all(promises);
    },
    handleForward() {
      console.log('handleForward called');
      if(this.activeComponentIndex === -1) {
        console.error('Current component not found in encounter component sequence');
        return;
      }
      if(this.activeComponentIndex + 1 >= this.encounterComponentSequence[this.encounter.encounter_type].length) {
        // end of encounter, close slides modal
        this.$emit('close');
        return;
      }
      this.currentSlideComponent = this.encounterComponentSequence[this.encounter.encounter_type][this.activeComponentIndex + 1];
    },
    handleBack() {
      console.log('handleBack called');
      if(this.activeComponentIndex === -1) {
        console.error('Current component not found in encounter component sequence');
        return;
      }
      if(this.activeComponentIndex === 0) {
        // first step, close modal
        this.$emit('close');
        return;
      }
      this.currentSlideComponent = this.encounterComponentSequence[this.encounter.encounter_type][this.activeComponentIndex - 1];
    },
    handleUpdateEncounterData(data) {
      // console.log('Updating encounter data with:', data);
      // update vue data reactively
      this.$set(this.encounterData, Object.keys(data)[0], data[Object.keys(data)[0]]);
    },
  },
  mounted () {
    // if encounter has no encounter type, redirect to encounter type select page subroute
    if(!this.encounter || !this.encounter.encounter_type) {
      // console.log('No encounter type found, showing appointment type select');
        this.currentSlideComponent = this.appointmentTypeSelectComponent;
    }
    if(this.encounter && this.encounter.encounter_type) {
      this.loadEncounterData();
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.modal-encounter {
  overflow-y: scroll !important;
}
.modal-header {
  margin-bottom: 15px;
}
.encounter-container {
  padding-bottom: 30px;
}
.loading {
  margin-top: 50px;
  margin-bottom: 50px;
}
.encounter-body {
  margin-top: 40px;
}
.full-page-slide .encounter-body {
  padding-top: 20px;
  position: relative;
}
.row-encounter-nav {
  background-color: fadeout(@major-color, 50%);

  > div {
    padding: 30px;
  }
  h5 {
    font-size: 16px;
    line-height: 18px;
  }
}
.row-step-nav {
  height: 100%;
  min-height: 100%;
}
.step-nav {
  .step {
    text-align: center;
    display: block;
    // margin-right: 50px;
    width: 65px;
    text-decoration: none;

    .cir {
      display: block;
      width: 15px;
      height: 15px;
      border: 1px solid @dark-color;
      border-radius: 100%;
      background-color: white;
      // margin-bottom: 3px;
      margin: 0 auto 3px;
    }
    .label {
      display: block;
      font-size: 10px;
      font-style: italic;
      margin: 0 auto;
    }
    &:hover:not( :disabled ),
    &:hover:not( .disabled ) {
      cursor: pointer;
      text-decoration: underline;

      .cir {
        background-color: @color-green;
        border-color: @dark-color;
      }
    }
    &:disabled,
    &.disabled {
      opacity: 1;
      color: @dark-color;
      
      .cir {
        border-color: @light-color;
      }
    }
  }
  .step.active {
    .cir {
      background-color: @dark-color;
    }
  }
  .step:last-child {
    margin-right: 0;
  }
}

</style>
